import type { ComponentProps, ReactNode } from 'react';
import { Button, Spinner } from '@utilities-one/gpm-ui';

import { useFormContext } from '@/library/form/contexts';

type SubmitButtonProps = {
  label?: string;
  children?: ReactNode;
  /**
   * Externally-driven busy flag, OR-ed with the form's own `isSubmitting`.
   * Use when the actual work happens outside the form callback (e.g. the
   * page invokes `mutate(...)` fire-and-forget and tracks `isPending` itself).
   */
  loading?: boolean;
  /** Externally-driven disabled flag (e.g. required fields still empty), OR-ed with the busy state. */
  disabled?: boolean;
  buttonProps?: ComponentProps<typeof Button>;
};

export function SubmitButton({ label, children, loading, disabled, buttonProps, ...props }: SubmitButtonProps) {
  const form = useFormContext();
  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => {
        const busy = isSubmitting || loading === true;
        return (
          <Button type="submit" disabled={busy || disabled === true} {...buttonProps} {...props}>
            {busy && <Spinner />}
            {children ?? label}
          </Button>
        );
      }}
    </form.Subscribe>
  );
}
